import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input.js";
import { useIPFilter } from "./IPFilterContext.js";

const DEBOUNCE_MS = 200;

export function IPFilterInput() {
  const { query, setQuery } = useIPFilter();
  const [local, setLocal] = useState(query);

  useEffect(() => {
    let cancelled = false;
    const t = window.setTimeout(() => {
      if (!cancelled) setQuery(local);
    }, DEBOUNCE_MS);
    return () => {
      cancelled = true;
      window.clearTimeout(t);
    };
  }, [local, setQuery]);

  return (
    <div className="relative mx-auto w-full max-w-md">
      <Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        placeholder="Search IP in loaded bans…"
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        className="pl-9"
        aria-label="Filter decisions by IP address"
      />
    </div>
  );
}
